import React from 'react';

/**
 * Utility hook to combine forwarded ref with internal ref.
 */
export function useCombinedRefs<T>(
    ...refs: React.Ref<T>[]
): React.MutableRefObject<T | null> {
    const targetRef = React.useRef<T>(null);
    React.useEffect(() => {
        refs.forEach(ref => {
            if (!ref) return;
            if (typeof ref === 'function') {
                ref(targetRef.current);
            } else {
                (ref as React.MutableRefObject<T | null>).current =
                    targetRef.current;
            }
        });
    }, [refs]);
    return targetRef;
}
